import React, { useContext, useState } from 'react';
import './styles.css';
import P from 'prop-types';
//import useWindowDimensions from '../../utils/utils';
import { Capitalize } from '../../utils/utils';
import { FormataValor } from '../../utils/utils';
//import { SacolaRodape } from '../SacolaRodape';
import { ValoresTotais } from '../ValoresTotais';
import { GlobalContext } from '../../contexts/HomeContext';
import { Image } from '../Image';
import EmptyBag from '../../img/empty_bag.png';
import { FinalizacaoRodape } from '../FinalizacaoRodape';
import { Modal } from '../Modal';

export const Conferencia = ({ param }) => {
  const { dadosApp, user } = useContext(GlobalContext);
  const [modalFinalizacao, setModalFinalizacao] = useState(false);
  const [modalLogin, setModalLogin] = useState(false);
  const obj = param.itens;

  const handleOnClick = (e) => {
    e.preventDefault();

    if (user.id === 0 && !dadosApp.aceitaPagamentoSemUsuario) {
      setModalLogin(true);
      return;
    }

    setModalFinalizacao(true);
  };

  return (
    <>
      <div className={`${param.origin == 'desktop' ? 'col-lg-4' : ''}`} id="sidebar_fixed">
        <div className="theiaStickySidebar">
          <div className="mobile_fixed box_order" style={{ display: 'block' }}>
            {param.origin == 'desktop' && (
              <div className="head">
                <h3>{dadosApp.TipoApp === 'DELIVERY' ? 'Sacola' : 'Pedido'}</h3>
                {/* <a href="asdasd" className="close_panel_mobile">
                  <i className="material-icons">close</i>
                </a> */}
              </div>
            )}

            <div className="main" style={{ paddingBottom: '0' }}>
              {obj.itens.length == 0 && (
                <ul className="clearfix" style={{ padding: '25px 25px 50px 25px' }}>
                  <>
                    {/* <h1>:(</h1> */}
                    <Image srcLocal={EmptyBag} />
                    <h4>Sua sacola esta vazia</h4>
                  </>
                </ul>
              )}
              {obj.itens.length > 0 &&
                obj.itens.map((item, index) => (
                  <ul key={'item' + index} className="clearfix" style={{ borderBottom: '1px solid #ededed' }}>
                    <li>
                      <span style={{ fontSize: '16px', marginLeft: '10px', color: '#3f3e3e' }}>
                        {FormataValor(item.VTotal)}
                      </span>
                      {/* {item.Produto.tipo_produto == 'PIZZA' && item.Produto.tipoPizza == 'FRACAO' && ( */}
                      {item.Produto.tipo_produto == 'PIZZA' && (
                        <p style={{ fontSize: '14px', margin: '0' }}>
                          {item.Produto.quantidade_texto + ' '} &#8287;
                          {Capitalize(item.Produto.descricao_produto)}
                        </p>
                      )}
                      {item.Produto.tipo_produto != 'PIZZA' && (
                        <p style={{ fontSize: '14px', margin: '0' }}>
                          {item.Produto.quantidade_texto + 'x '} &#8287;
                          {Capitalize(item.Produto.descricao_produto)}
                        </p>
                      )}
                      {item.ItensMontagemText.length > 0 && (
                        <p style={{ fontSize: '14px', margin: '7px 0', color: '#717171' }}>{item.ItensMontagemText}</p>
                      )}
                      {item.Produto.observacao_pedido.length > 0 && (
                        <p style={{ fontSize: '14px', margin: '7px 0', color: '#717171' }}>
                          {'Obs. ' + item.Produto.observacao_pedido}
                        </p>
                      )}
                    </li>
                  </ul>
                ))}
            </div>
            <div className="main" style={{ paddingTop: '0', paddingBottom: '0', overflow: 'hidden' }}>
              {obj.itens.length > 0 && (
                <ValoresTotais
                  origin={param.origin}
                  taxa_text={
                    (dadosApp.Empresa.Config.taxa_tipo == 'Km' && 'a calcular') ||
                    (dadosApp.Empresa.Config.taxa_tipo == 'Regiao' && 'a calcular') ||
                    (dadosApp.Empresa.Config.taxa_tipo == 'Região' && 'a calcular')
                  }
                  subtotal={obj.subtotal}
                  desconto={obj.desconto}
                  acrescimo={obj.acrescimo}
                  taxa={obj.taxa}
                  total={obj.total}
                  isDelivery={dadosApp.TipoApp === 'DELIVERY'}
                />
              )}
            </div>

            {dadosApp.Empresa.Config.aceitar_pagamento &&
              (dadosApp?.Empresa?.Config?.qlub ? (
                <div
                  style={{
                    padding: '1rem',
                    textAlign: 'center',
                    backgroundColor: '#fef9e3',
                    borderRadius: '0.5rem',
                    border: '1px solid #fde047',
                    // margin: '0 1rem',
                  }}
                >
                  <p
                    style={{
                      fontSize: '0.875rem',
                      color: '#854d0e',
                      margin: 0,
                    }}
                  >
                    Para efetuar o pagamento, escaneie a comanda e escolha <strong>Pagar Agora</strong>
                  </p>
                </div>
              ) : (
                <FinalizacaoRodape isCompleted={true} isPagOnline={true} valor={obj.total} onClick={handleOnClick} />
              ))}

            {/* {dadosApp.Empresa.Config.aceitar_pagamento && (
              <FinalizacaoRodape isCompleted={true} isPagOnline={true} valor={obj.total} onClick={handleOnClick} />
            )} */}
          </div>
        </div>
      </div>

      {/* {obj.itens.length > 0 && width < 992 && <SacolaRodape param={param} />} */}

      {modalFinalizacao && (
        <Modal
          title="Pagamento"
          isFooter={false}
          visibility={modalFinalizacao ? 'block' : 'none'}
          page="FINALIZACAO"
          param={{ closeModal: () => setModalFinalizacao(false), conferencia: obj }}
          btnOnClickClose={() => setModalFinalizacao(false)}
        />
      )}

      {modalLogin && (
        <Modal
          title="Login"
          isFooter={true}
          visibility={modalLogin}
          page="LOGIN"
          btnOnClickClose={() => setModalLogin(false)}
        />
      )}
    </>
  );
};

Conferencia.propTypes = {
  param: P.object,
};
